const QF_Type = ["QUANTUM FIBER", "QF", "QF-II", "QUANTUM FIBER II"];
const CTL_Type = [
  "CENTURY LINK",
  "CTL",
  "CTL QUALIFIED",
  "CTL_QUALIFIED",
  "COPPER QUALIFIED",
];
const migrated_CTL_Type = ["CENTURY LINK", "CENTURY_LINK"];
const Other4GLTE_Type = ["4GLTE"];

const initGTM = () => {
  window.dataLayer = window.dataLayer || [];
};
const predefinedCompanyName = {
  "QUANTUM FIBER": "QF",
  QF: "QF",
  "QF-II": "QF",
  "QUANTUM FIBER II": "QF",
  "CENTURY LINK": "MIGRATED_CTL",
  CTL: "CTL",
  "CTL QUALIFIED": "CTL",
  CTL_QUALIFIED: "CTL",
  "COPPER QUALIFIED": "CTL",
  "4GLTE": "4GLTE",
  CENTURY_LINK: "MIGRATED_CTL",
  BS: "BRSPD",
};
const getCustomerType = (companyName, chekIsMigrated = false) => {
  let returnData = "";
  if (
    companyName &&
    companyName !== null &&
    companyName !== undefined &&
    companyName !== ""
  ) {
    returnData =
      predefinedCompanyName?.[companyName?.toString()?.toUpperCase()];
  } else {
    returnData =
      predefinedCompanyName?.[
        localStorage?.getItem("headersSiteId")?.toString()?.toUpperCase()
      ];
    //returnData ="Comapany name not available";
  }
  return returnData === undefined
    ? ""
    : returnData &&
        chekIsMigrated &&
        localStorage?.getItem("migratedCTLUser") === "true"
      ? "MIGRATED_CTL_Account_Management"
      : `${returnData}_Account_Management`;
};
const onPageLoadGTM = (
  pageName,
  step,
  sessionId,
  billingAccountNumber,
  companyName,
) => {
  window.dataLayer.push({
    page: {
      pageType: `${getCustomerType(companyName, true)}`,
      pageName: pageName || "",
    },
    flow: {
      name: "BRSPD_Fiber_EC_Flow",
      step: step || undefined,
    },
    sessionId: sessionId,
    billingAccountNumber: billingAccountNumber,
    channel: "digital",
  });
};

const backButtonClickedGTM = (
  name,
  step,
  sessionId,
  billingAccountNumber,
  companyName,
) => {
  window.dataLayer.push({
    event: "back",
    pageType: `${getCustomerType(companyName, true)}`,
    flow: {
      name: name,
      step: step,
    },
    sessionId: sessionId,
    billingAccountNumber: billingAccountNumber,
    channel: "digital",
  });
};

const errorConditionGTM = (
  name,
  step,
  errorCode,
  errorName,
  sessionId,
  billingAccountNumber,
  companyName,
  loggedIn,
) => {
  window.dataLayer.push({
    event: "error",
    pageType: `${getCustomerType(companyName, loggedIn)}`,
    flow: {
      name: name,
      step: step,
    },
    errorCode: errorCode,
    errorName: errorName,
    sessionId: sessionId,
    billingAccountNumber: billingAccountNumber,
    channel: "digital",
  });
};
const LoginFlowErrorGTM = (
  stepName,
  errorCode,
  flowType,
  userStatus,
  sessionId,
  event,
  companyName,
  loggedIn,
) => {
  window.dataLayer.push({
    event: event,
    pageType: `${getCustomerType(companyName, loggedIn)}`,
    stepName: stepName,
    errorCode: errorCode,
    flowType: flowType,
    sessionId: sessionId,
    userStatus: userStatus,
    channel: "digital",
  });
};

const finduserGTMWithFlow = (eventName) => {
  window.dataLayer.push({
    event: eventName,
    pageType: "",
    flow: "findusername",
    channel: "digital",
    sessionId: sessionStorage?.getItem("sessionId"),
  });
};
const findUserGTMErrorWithFlow = (eventName, errorMsg) => {
  window.dataLayer.push({
    event: eventName,
    pageType: "",
    flow: "findusername",
    channel: "digital",
    errorCode: errorMsg,
    sessionId: sessionStorage?.getItem("sessionId"),
  });
};

const securityPINSubmitGTM = (stepName, errorMsg) => {
  window.dataLayer.push({
    event: "Customer PIN submitted",
    stepName: stepName,
    codeStatus: errorMsg ? "failed" : "success",
    pageType: "",
    flow: "",
    channel: "digital",
    errorCode: errorMsg,
    sessionId: sessionStorage?.getItem("sessionId"),
  });
};

const SecurityPINModalClosedGTM = (event, stepName) => {
  window.dataLayer.push({
    event: event,
    stepName: stepName,
    pageType: "",
    flow: "",
    channel: "digital",
    sessionId: sessionStorage?.getItem("sessionId"),
  });
};

const loginGTM = (eventName, username, companyName, flowType, errorCode) => {
  window.dataLayer.push({
    event: eventName,
    pageType: `${getCustomerType(companyName)}`,
    //event: "digital_login_acct_mgmt",
    user: username,
    channel: "digital",
    sessionId: sessionStorage?.getItem("sessionId"),
    flow: flowType,
    errorCode: errorCode,
  });
};
const sendEventGTMLog = (eventName, companyName) => {
  window.dataLayer.push({
    event: eventName,
    pageType: `${getCustomerType(companyName)}`,
    channel: "digital",
    sessionId: sessionStorage?.getItem("sessionId"),
    loginSource: "web",
    otpchannel: "",
    flowtype: "",
  });
};

const sendBannerEventsGTM = (eventName, companyName, sessionId,contentName,flow,contentPriority,linkText,availableProducts) => {
  window.dataLayer.push({
    event: eventName,
    pageType: `${getCustomerType(companyName)}`,
    channel: "digital",
    sessionId: sessionId,
    loginSource: "web",
    contentName: contentName,
    flow: flow,
    contentPriority: contentPriority,
    linkText: linkText,
    availableProducts: availableProducts,
  });
};
const serviceUpgradeCTAEventGTM = (eventName,companyName,sessionId,contentName,flow,contentPriority,linkText,availableProducts) => {
  window.dataLayer.push({
    event: eventName,
    pageType: `${getCustomerType(companyName)}`,
    channel: "digital",
    sessionId: sessionId,
    // loginSource: "web",
    contentName: contentName,
    flow: flow,
    contentPriority: contentPriority,
    linkText: linkText,
    availableProducts: availableProducts,
  });
};
const sendLoginEventGTMLog = (eventName, companyName) => {
  const objData = {
    pageType: `${getCustomerType(companyName)}`,
    channel: "digital",
    sessionId: sessionStorage?.getItem("sessionId"),
    loginSource: "web",
  };
  window.dataLayer.push({ ...objData, ...eventName });
};
const seamLessMigrationGTM = (
  eventName,
  companyName,
  accountType,
  sessionId,
) => {
  window.dataLayer.push({
    event: eventName,
    pageType: `${getCustomerType(companyName)}`,
    channel: "digital",
    sessionId: sessionId,
    billingType: accountType,
  });
};

const seamLessMigrationSubmitOrderGTM = (
  eventName,
  companyName,
  accountType,
  order_number,
  orderDate,
  existingPlanName,
  InternetPlanName,
  voiceAdded,
  potsPlanonly,
  sessionId,
) => {
  window.dataLayer.push({
    event: eventName,
    pageType: `${getCustomerType(companyName)}`,
    channel: "digital",
    sessionId: sessionId,
    billingType: accountType,
    seamless_migration: true,
    order_number: order_number,
    orderdate: orderDate,
    total_home_tech_support: false,
    internetchange: potsPlanonly ? "POTS Customer" : "upgrade",
    voiceAdded: voiceAdded,
    voiceRemoved: false,
    newInternetPlanName: InternetPlanName,
    existingPlanSpeed: existingPlanName,
    newPlanSpeedTier: potsPlanonly ? "" : "100M",
    total_home_internet_controls: false,
  });
};

const sendEventGTMLogAutopay = (eventName, companyName, paymentType) => {
  window.dataLayer.push({
    event: eventName,
    pageType: `${getCustomerType(companyName)}`,
    channel: "digital",
    sessionId: sessionStorage?.getItem("sessionId"),
    paymentType: paymentType,
  });
};

const shopConfirmOrderGTM = (
  orderNumber,
  orderDate,
  VasAdded,
  internetchange,
  voiceAddedOrRemoved,
  InternetPlanName,
  sessionId,
  existingPlanSpeed,
  vasChangeOrderIQ,
  internetChangeNewSpeedTiers,
  billingType,
  selectedProduct,
  installationMethod = "",
  supplementOrder,
  wholeHome,
  wh_quantity,
  ows="",
  supplementorderOffers = [],
  dropType,
  vasmfoffer,
  contentName = "",
  flow = "",
  availableProducts = "",
) => {
  // Backward compatibility: some call sites may pass offers in the ows slot.
  let normalizedOws = ows;
  let normalizedSupplementOrderOffers = supplementorderOffers;
  if (
    (Array.isArray(ows) || (ows && typeof ows === "object")) &&
    (supplementorderOffers === undefined ||
      supplementorderOffers === null ||
      (Array.isArray(supplementorderOffers) && supplementorderOffers.length === 0))
  ) {
    normalizedSupplementOrderOffers = ows;
    normalizedOws = false;
  }

  const offers = [];
  if (Array.isArray(normalizedSupplementOrderOffers)) {
    offers.push(...normalizedSupplementOrderOffers);
  } else if (
    normalizedSupplementOrderOffers &&
    typeof normalizedSupplementOrderOffers === "object"
  ) {
    offers.push(normalizedSupplementOrderOffers);
  }


   if (Array.isArray(vasmfoffer) && vasmfoffer.length > 0) {
    offers.push(...vasmfoffer);
  }
  window.dataLayer.push({
    event: "change_Order_confirm_button",
    channel: "digital",
    billingType: billingType,
    orderNumber: orderNumber,
    orderdate: orderDate,
    total_home_tech_support: VasAdded === "add" ? true : false,
    internetchange: internetchange,
    voiceAdded: voiceAddedOrRemoved === "add" ? true : false,
    voiceRemoved: voiceAddedOrRemoved === "delete" ? true : false,
    newInternetPlanName: InternetPlanName,
    existingPlanSpeed: existingPlanSpeed,
    newPlanSpeedTier: internetChangeNewSpeedTiers,
    total_home_internet_controls: vasChangeOrderIQ === true,
    selectedProducts: selectedProduct,
    sessionId: sessionId,
    installation_method: installationMethod,
    supplementOrder: supplementOrder,
    whole_home_wifi: wholeHome,
    whole_home_wifi_quantity: wh_quantity,
    ows: normalizedOws === true,
    offers,
    drop_type: dropType || "",
    contentName: contentName,
    flow: flow,
    availableProducts: availableProducts,
  });
};
const upgradingToEightGPlan = (event, companyName, error, accountType) => {
  window.dataLayer.push({
    event: event,
    pageType: `${getCustomerType(companyName, true)}`,
    channel: "digital",
    errorCode: "success",
    sessionId: sessionStorage?.getItem("sessionId"),
  });
};
const forgotPasswordGTM = (companyName, username) => {
  window.dataLayer.push({
    event: "digital_forgot_password_acct_mgmt",
    pageType: `${getCustomerType(companyName)}`,
    channel: "digital",
    user: username,
    sessionId: sessionStorage?.getItem("sessionId"),
  });
};

const homeGTM = (sessionId, companyName, accountType, accountTenure, accountStatus, autoPay, paperlessBilling, currentAmountDue,
  billDueDate, lastInvoiceAmount, lastBillDate, internet_plan_speed, stateCode, wireCenter, voice, offers1q, retentionOfferUser,
  addon, eightGuser, paymentType, offerCampaignName, offerType, isSupplementOrderEligible, churnDiscountType, churnDiscountAmount, churnDiscountDuration, addressLevelPricingOffers, advancePayment, dropType, vasmfoffer,hasSecurityPin, fiberOffer12MonthDiscountData) => {
  const offers = [];
  if (offerCampaignName) {
    offers.push({ "campaignName": offerCampaignName, "type": offerType });
  }
  if (churnDiscountType) {
    offers.push(churnBannerGTM(churnDiscountType, churnDiscountAmount, churnDiscountDuration));
  }
  if (Array.isArray(addressLevelPricingOffers) && addressLevelPricingOffers.length > 0) {
    offers.push(...addressLevelPricingOffers);
  }
  if (Array.isArray(vasmfoffer) && vasmfoffer.length > 0) {
    offers.push(...vasmfoffer);
  }
  if (Array.isArray(fiberOffer12MonthDiscountData) && fiberOffer12MonthDiscountData.length > 0) {
    offers.push({
      "campaignName": "Fiber holiday offer-2026",
      "term": "12", // e.g., "12"
      "type": "$10 Fiber Internet Discount for 12 Months",
      "value": fiberOffer12MonthDiscountData[0]?.Discvalue,// -10.0
    });
  }

  window.dataLayer.push({
    event: "digital_home_acct_mgmt",
    pageType: `${getCustomerType(companyName, true)}`,
    channel: "digital",
    sessionId: sessionId,
    accountType: accountType,
    accountTenure: accountTenure,
    accountStatus: accountStatus,
    autoPay: autoPay,
    paperlessBilling: paperlessBilling,
    currentAmountDue: currentAmountDue,
    billDueDate: billDueDate,
    lastInvoiceAmount: lastInvoiceAmount,
    lastBillDate: lastBillDate,
    internet_plan_speed: internet_plan_speed,
    state_code: stateCode,
    wire_center: wireCenter,
    voice: voice,
    offers1q,
    paymentType,
    retentionOfferUser,
    "Add-on": {
      total_home_tech_support: addon?.total_home_tech_support,
      wifi_extender: addon?.wifi_extender,
      total_home_internet_control: addon?.total_home_internet_control,
      eont_router: addon?.eont_router,
      eont_wifiExtender: addon?.eont_wifiExtender,
    },
    eightGuser,
    offers,
    "supplementEligible": !!isSupplementOrderEligible,
    depositAmount: advancePayment,
    drop_type: dropType || "",
    accountPin: hasSecurityPin,
  });
};

const qbpPaymentsGTM = ({ event, error = "" }) => {
  const companyName = localStorage?.getItem("headersSiteId");
  window.dataLayer.push({
    event,
    pageType: `${getCustomerType(companyName, true)}`,
    flow: "auth or nonauth qbp payments flow",
    channel: "digital",
    sessionId: sessionStorage?.getItem("sessionId"),
    errorCode: error,
  });
};

const payNowPaymentsGTM = ({ event, error = "" }) => {
  const companyName = localStorage?.getItem("headersSiteId");
  window.dataLayer.push({
    event,
    pageType: `${getCustomerType(companyName, true)}`,
    flow: "auth or nonauth qbp payments flow",
    channel: "digital",
    sessionId: sessionStorage?.getItem("sessionId"),
    error,
  });
};
const upcomingPaymentGTM = (
  event,
  companyName,
  error,
  accountType,
  billingAccountNumber = "",
) => {
  window.dataLayer.push({
    event: event,
    pageType: `${getCustomerType(companyName, true)}`,
    channel: "digital",
    errorCode: error,
    sessionId: sessionStorage?.getItem("sessionId"),
    accountType: accountType,
    billingAccountNumber: billingAccountNumber,
  });
};
const AddUpdatePaymentGTM = (
  event,
  companyName,
  error,
  accountType,
  billingAccountNumber = "",
) => {
  window.dataLayer.push({
    event: event,
    pageType: `${getCustomerType(companyName, true)}`,
    channel: "digital",
    errorCode: error,
    sessionId: sessionStorage?.getItem("sessionId"),
    accountType: accountType,
    billingAccountNumber: billingAccountNumber,
  });
};

const authenticQbpGTM = ({ flowType, companyName }) => {
  window.dataLayer.push({
    event: "digital_authentic_quickbillpay_acct_mgmt",
    pageType: `${getCustomerType(companyName, true)}`,
    flow: flowType,
    channel: "digital",
    sessionId: sessionStorage?.getItem("sessionId"),
  });
};

const signInButtonGTM = ({ event }) => {
  window.dataLayer.push({
    event: event,
    channel: "digital",
    sessionId: sessionStorage?.getItem("sessionId"),
    pageType: "new login page",
    loginSource: "web",
  });
};

const nonAuthenticQBPGTM = ({
  companyName,
  accountType,
  accountTenure,
  accountStatus,
  autoPay,
  paperlessBilling,
  currentAmountDue,
  billDueDate,
  lastInvoiceAmount,
  lastBillDate,
  internet_plan_speed,
  stateCode,
  wireCenter,
  voice,
  flowType,
}) => {
  window.dataLayer.push({
    event: "digital_nonauthentic_quickbillpay_acct_mgmt",
    pageType: `${getCustomerType(companyName)}`,
    channel: "digital",
    sessionId: sessionStorage?.getItem("sessionId"),
    accountType,
    accountTenure,
    accountStatus,
    autoPay,
    paperlessBilling,
    currentAmountDue,
    billDueDate,
    lastInvoiceAmount,
    lastBillDate,
    internet_plan_speed,
    stateCode,
    wireCenter,
    voice,
    flowType,
    companyName,
  });
};

const nonAuthenticPAGTM = ({
  companyName,
  accountType,
  accountTenure,
  accountStatus,
  autoPay,
  paperlessBilling,
  currentAmountDue,
  billDueDate,
  lastInvoiceAmount,
  lastBillDate,
  internet_plan_speed,
  stateCode,
  wireCenter,
  voice,
}) => {
  window.dataLayer.push({
    event: "digital_nonauthentic_paymentarrangements_acct_mgmt",
    pageType: `${getCustomerType(companyName)}`,
    channel: "digital",
    sessionId: sessionStorage?.getItem("sessionId"),
    accountType,
    accountTenure,
    accountStatus,
    autoPay,
    paperlessBilling,
    currentAmountDue,
    billDueDate,
    lastInvoiceAmount,
    lastBillDate,
    internet_plan_speed,
    stateCode,
    wireCenter,
    voice,
  });
};

// const accountSettingGTM = () => {
//   window.dataLayer.push({
//     event: "digital_account-setting_acct_mgmt",
//     channel: "digital",
//   });
// };

// const viewPaymentsGTM = () => {
//   window.dataLayer.push({
//     event: "digital_viewPayments_acct_mgmt",
//     channel: "digital",
//   });
// };

// const paymentMethodsGTM = () => {
//   window.dataLayer.push({
//     event: "digital_paymentMethods_mgmt",
//     channel: "digital",
//   });
// };

// const appointmentGTM = () => {
//   window.dataLayer.push({
//     event: "digital_appointment_mgmt",
//     channel: "digital",
//   });
// };

// const helpandsupportGTM = () => {
//   window.dataLayer.push({
//     event: "digital_help-and-support_mgmt",
//     channel: "digital",
//   });
// };

const sideMenuClickGTM = (eventName, companyName, username) => {
  window.dataLayer.push({
    event: eventName,
    pageType: `${getCustomerType(companyName, true)}`,
    channel: "digital",
    user: username,
    sessionId: sessionStorage?.getItem("sessionId"),
  });
};

const forgotUserNameGTM = () => {
  window.dataLayer.push({
    event: "digital_forgot_username_acct_mgmt",
    channel: "digital",
    sessionId: sessionStorage?.getItem("sessionId"),
  });
};

const signupGTM = () => {
  window.dataLayer.push({
    event: "digital_create_account_acct_mgmt",
    channel: "digital",
    sessionId: sessionStorage?.getItem("sessionId"),
  });
};

const logoutGTM = (companyName, username) => {
  window.dataLayer.push({
    event: "digital_logout_acct_mgmt",
    pageType: `${getCustomerType(companyName, true)}`,
    channel: "digital",
    user: username,
    sessionId: sessionStorage?.getItem("sessionId"),
  });
};

const addEneventGTM = (
  eventName,
  sessionId,
  billingAccountNumber,
  companyName,
  errorCode,
) => {
  const data = {
    event: eventName || undefined,
    pageType: `${getCustomerType(companyName, true)}`,
    channel: "digital",
    sessionId: sessionId,
    billingAccountNumber: billingAccountNumber,
  };
  if (errorCode) {
    data.errorCode = errorCode;
  }
  window.dataLayer.push(data);
};

const uniLogineventGTM = (loginMethod, loginValue) => {
  window.dataLayer.push({
    event: "uni-login-account-management",
    pageType: "BRSPD_Fiber_Account_Management",
    channel: "digital",
    loginMethod: loginMethod,
    loginValue: loginValue,
    sessionId: sessionStorage?.getItem("sessionId"),
  });
};

const forgetPasswordSuccessGTM = (eventName, flowType, companyName) => {
  window.dataLayer.push({
    event: eventName,
    pageType: `${getCustomerType(companyName)}`,
    flow: flowType,
    channel: "digital",
    sessionId: sessionStorage?.getItem("sessionId"),
  });
};

const payNowGTM = (
  eventName,
  flowType,
  companyName,
  billingAccountNumber,
  error = "",
) => {
  window.dataLayer.push({
    event: eventName,
    pageType: `${getCustomerType(companyName, true)}`,
    flow: flowType,
    channel: "digital",
    sessionId: sessionStorage?.getItem("sessionId"),
    billingAccountNumber: billingAccountNumber,
    errorCode: error,
  });
};

const outageBannerGTM = (eventName, companyName) => {
  window.dataLayer.push({
    event: eventName,
    pageType: `${getCustomerType(companyName)}`,
    channel: "digital",
    sessionId: sessionStorage?.getItem("sessionId"),
  });
};

const withWifiExtChatGTM = (eventName, companyName) => {
  window.dataLayer.push({
    event: eventName,
    pageType: `${getCustomerType(companyName)}`,
    channel: "digital",
    sessionId: sessionStorage?.getItem("sessionId"),
  });
};

const addWifiExtChatGTM = (eventName, companyName) => {
  window.dataLayer.push({
    event: eventName,
    pageType: `${getCustomerType(companyName)}`,
    channel: "digital",
    sessionId: sessionStorage?.getItem("sessionId"),
  });
};

/* Movers */

const moverEntryGTM = (
  eventName,
  companyName,
  accountType,
  planSpeed,
  stateCode,
  wireCenter,
) => {
  window.dataLayer.push({
    event: eventName,
    pageType: `${getCustomerType(companyName)}`,
    channel: "digital",
    sessionId: sessionStorage?.getItem("sessionId"),
    accountType: accountType,
    internet_plan_speed: planSpeed,
    state_code: stateCode,
    wire_center: wireCenter,
  });
};

const moverLandingPageEvent = (
  eventName,
  companyName,
  accountType,
  planSpeed,
  stateCode,
  wireCenter,
  options = {},
) => {
  const { isMoveEligible, moveCostOrScenario } = options;

  const eventData = {
    event: eventName,
    channel: "digital",
    accountType: accountType,
    internet_plan_speed: planSpeed,
    state_code: stateCode,
    wire_center: wireCenter,
    pageType: `${getCustomerType(companyName)}`,
    sessionId: sessionStorage?.getItem("sessionId"),
  };

  if (isMoveEligible !== undefined) {
    eventData.seamless_move_eligible = isMoveEligible;

    if (isMoveEligible) {
      eventData.seamless_move_cost = moveCostOrScenario;
    } else {
      eventData.seamless_move_scenario = moveCostOrScenario;
    }
  }
  if (isMoveEligible === undefined && moveCostOrScenario !== undefined) {
    eventData.seamless_move_cost = moveCostOrScenario;
  }
  window.dataLayer.push(eventData);
};

const confirmMoveGTM = (
  eventName,
  isMoveSuccess,
  companyName,
  accountType,
  planSpeed,
  stateCode,
  wireCenter,
  moveCost,
  errorCode,
  orderNumber,
) => {
  const eventData = {
    event: eventName,
    seamless_move_confirmation: isMoveSuccess,
    channel: "digital",
    accountType: accountType,
    internet_plan_speed: planSpeed,
    state_code: stateCode,
    wire_center: wireCenter,
    seamless_move_cost: moveCost,
    pageType: `${getCustomerType(companyName)}`,
    sessionId: sessionStorage?.getItem("sessionId"),
  };
  if (isMoveSuccess) {
    eventData["orderNumber"] = orderNumber;
  } else {
    eventData["errorCode"] = errorCode;
  }
  window.dataLayer.push({
    ...eventData,
  });
};

const churnBannerGTM = (offerType, offerAmount, offerDuration) => {
  return {
    type: "AM Churn Discounts",
    campaignName: offerType,
    value: offerAmount, 
    term: offerDuration
  }
};

export {
  onPageLoadGTM,
  backButtonClickedGTM,
  errorConditionGTM,
  LoginFlowErrorGTM,
  initGTM,
  loginGTM,
  forgotPasswordGTM,
  forgotUserNameGTM,
  homeGTM,
  signupGTM,
  addEneventGTM,
  nonAuthenticQBPGTM,
  nonAuthenticPAGTM,
  shopConfirmOrderGTM,
  sendEventGTMLog,
  sendEventGTMLogAutopay,
  upgradingToEightGPlan,
  //paymentMethodsGTM,
  //helpandsupportGTM,
  //appointmentGTM,
  //accountSettingGTM,
  //viewPaymentsGTM,
  sideMenuClickGTM,
  uniLogineventGTM,
  logoutGTM,
  finduserGTMWithFlow,
  findUserGTMErrorWithFlow,
  forgetPasswordSuccessGTM,
  payNowGTM,
  authenticQbpGTM,
  qbpPaymentsGTM,
  upcomingPaymentGTM,
  AddUpdatePaymentGTM,
  outageBannerGTM,
  withWifiExtChatGTM,
  addWifiExtChatGTM,
  seamLessMigrationGTM,
  seamLessMigrationSubmitOrderGTM,
  signInButtonGTM,
  moverEntryGTM,
  moverLandingPageEvent,
  confirmMoveGTM,
  securityPINSubmitGTM,
  SecurityPINModalClosedGTM,
  sendLoginEventGTMLog,
  sendBannerEventsGTM,
  serviceUpgradeCTAEventGTM
};
